import { Box, Text, Title } from "@repo/ui/core";
import { motion } from "framer-motion";

type Props = {
  title: string;
  subtitle?: string;
};

export function SlideTitle({ title, subtitle }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Box
        h={3}
        w={64}
        mb={10}
        style={{ background: "var(--customer-accent)", borderRadius: 2 }}
      />
      <Title
        order={1}
        size="clamp(30px, 4vw, 52px)"
        fw={800}
        style={{ letterSpacing: "-0.02em", lineHeight: 1.1 }}
        mb={4}
      >
        {title}
      </Title>
      {subtitle && (
        <Text size="sm" c="dimmed">
          {subtitle}
        </Text>
      )}
    </motion.div>
  );
}
